export default "__VITE_ASSET__DKc_bGNp__"